import cloneDeep from "lodash/cloneDeep";
import uuid from "uuid";

import * as types from '../actions/actionTypes';
import {getCurrencyPosition, getCurrencySign} from "../misc/helpers";
import {MEASURE_UNITS} from "../bvcomponents/sqft/constants";
import Config, {getCommonVisualizerType, IS_LIXIL_SERVERS} from "../config";
import * as fabricatorHardcode from "../misc/fabricatorHardcode";
import {IS_PRODUCT_JOURNEY} from "../config";
import {hardcodedTaxObject} from "../misc/constants";

const checkMeasureUnit = (mUnit) => {
  return (mUnit === "metric" || mUnit === MEASURE_UNITS.Metric) ? MEASURE_UNITS.Metric : MEASURE_UNITS.Imperial
};

const initialState = {
  received: false,
  fabricatorSubscriptions: [],
  settings: { // current active
    currency: "USD",
    currencySign: "$",
    currencyPosition: "left",
    measureUnit: null, // Imperial(default) || Metric
    useCategorySwitching: false,
    useShipperHQ: false,
    useFabricatorCostPrices: false,
    hideYourListButton: false,
    useMarkUpFeaturesRequests: false,
  },
  kitchenSettings: {},
  bathroomSettings: {},
  fabricatorTaxes: [],
  ...fabricatorHardcode.fabricatorsHardcodeObject,
  hidePricesFromUser: Array.isArray(document.dashboardUserPermissions) && document.dashboardUserPermissions.some(permission => {
    return permission.ProtectedAreaId === 9000 && permission.AccessRights === 0
  }),
  enableProductionSheet: false,
  wasCreatedFromFabricator: "",
  useIMEAPI: false,
  useIMEAPI_PartnerId: 0,
  receiptSettings: {}, // "{signIsRequired, showThumbnailsAndDescriptions, hideSignatureField, doNotFillNameAndDate, hideReceiptEmails}"
  aiSettings: {
    enableAI: false,
  }, // "{enableAI, enableAIDashboard, aiGroups: []}"
};

const applyDashboardSetting = (settings, property) => {
  if (!settings) {
    return false
  }
  if (document.kvConfig.isBackend) {
    return settings[property + "Dashboard"]  // disable property in the dashboard mode if it is disabled
  }
  return settings[property]
}

const getDashboardModeSettings = (settings) => {
  const dashboardProps = ["twoFA", "leadCapture", "leadCaptureProduct", "clickLeadCapture", "enableQuote",
    "enableScheduling", "leadCaptureShoppingCart", "leadCaptureOnQuote", "clickLeadCaptureOnQuote",
    "showVisualizerTutorial", "showSqftTutorial", "showSlabMode", "useShipping", "sureTax", "hideSku", "showSalePrices"];
  dashboardProps.forEach(property => {
    if (settings && settings[property] && !settings[property + "Dashboard"] && document.kvConfig.isBackend) {
      settings[property] = false  // disable property in the dashboard mode if it is disabled
    } else if (settings && !settings[property] && settings[property + "Dashboard"] && document.kvConfig.isBackend) {
      settings[property] = true   // enable simple property in dashboard mode (to simplify code)
    }
  })
  return settings
}

export const parseFabricatorSettingsOLD = (payload) => {  //todo remove this after we push staging backend
  const actionPayload = cloneDeep(payload); // this is needed to other reducers! Object assign doesn't deeply cloning
  let bathroomSettings = actionPayload.settings || {};
  let kitchenSettings = actionPayload.settings || {};
  let fireplaceSettings = actionPayload.settings || {};
  let laundryRoomSettings = actionPayload.settings || {};
  if (kitchenSettings.kitchenToggles) {
    Object.keys(kitchenSettings.kitchenToggles).forEach((oldKey) => {
      const ignoreProperties = ["showSqftTutorial", "showSlabMode"];
      if (!ignoreProperties.some(prop => oldKey.includes(prop))) {
        const newKey = oldKey.split("Kitchen")[0]
        delete Object.assign(kitchenSettings.kitchenToggles, {[newKey]: kitchenSettings.kitchenToggles[oldKey] })[oldKey];
      }
    })
    kitchenSettings.kitchenToggles.checkout = kitchenSettings.kitchenToggles.checkout || kitchenSettings.kitchenToggles.checkOut; // fix for incorrect property name
    kitchenSettings = Object.assign({}, actionPayload.settings, kitchenSettings.kitchenToggles);
    delete kitchenSettings.checkOut; // we don't need to keep it not to use it in future
    delete kitchenSettings.kitchenToggles; // we don't need to keep it not to use it in future
    kitchenSettings = getDashboardModeSettings(kitchenSettings);
  }
  bathroomSettings = getDashboardModeSettings(bathroomSettings);
  delete bathroomSettings.kitchenToggles; // we don't need to keep it not to use it in future
  return {
    settings: (document.kvConfig.visualizerType === "Kitchen" || document.kvConfig.visualizerType === "kvScene") ? kitchenSettings : bathroomSettings, // current active
    kitchenSettings,
    bathroomSettings,
    fireplaceSettings,
    laundryRoomSettings,
  }
}

const generalProperties = ["deposit", "depositDisclaimer", "depositMessage", "docuSignAuth", "enableDeposit",
  "enableDisclaimer", "enableDocuSign", "hasPaymentGateway", "language", "masterContractFields", "masterContractFullUrl",
  "measurement", "useContractSigning"];

export const parseFabricatorSettings = (payload) => {
  if (IS_LIXIL_SERVERS) {
    //todo remove this after we push backend on Lixil
    return parseFabricatorSettingsOLD(payload);
  }
  let settingsObject = {
    settings: {},
    kitchenSettings: {},
    bathroomSettings: {},
    fireplaceSettings: {},
    laundryRoomSettings: {},
  };
  if (!payload.settings.toolSettings) {
    return settingsObject
  }
  const actionPayload = cloneDeep(payload); // this is needed to other reducers! Object assign doesn't deeply cloning
  Object.keys(actionPayload.settings.toolSettings).forEach(visType => {
    settingsObject[visType + "Settings"] = Object.assign(
      {},
      getDashboardModeSettings(actionPayload.settings.toolSettings[visType]),
      {
        checkout: actionPayload.settings.toolSettings[visType].checkout ||actionPayload.settings.toolSettings[visType].checkOut // fix for incorrect property name
      });
    delete settingsObject[visType + "Settings"].checkOut; // we don't need to keep it not to use it in future
    generalProperties.forEach(property => { // here we set the same property into each room fabricator settings
      // to prevent all components changing to take data from fabricatorData instead of fabricatorData.settings
      settingsObject[visType + "Settings"][property] = actionPayload.settings[property];
    })
  });
  const currentSettingsProperty = getCommonVisualizerType() + "Settings";
  settingsObject.settings = settingsObject[currentSettingsProperty]; // current settings
  return settingsObject
}

const getFinalSettings = (settings, stateSettings, fabricatorResponse) => {

  if (IS_PRODUCT_JOURNEY && window.location.href.includes("colonial_")) {
    settings["leadCaptureShoppingCart"] = false;
    settings["enableQuote"] = false;
  }

  const isCaesarStone = fabricatorHardcode.hardCodeIsCaesarStone();
  const isDeStefano = fabricatorHardcode.hardCodeIsDeStefano();
  return Object.assign({}, stateSettings, {
    ...settings,
    leadCapture: IS_PRODUCT_JOURNEY ? settings.leadCaptureProduct : settings.leadCapture,
    measureUnit: checkMeasureUnit(settings.measurement),
    currencySign: getCurrencySign(settings.currency, (fabricatorResponse && fabricatorResponse.settings) ? fabricatorResponse.settings : settings),
    currencyPosition: getCurrencyPosition(settings.currency),
    priceWorksheetEnabled: true,
    enableSharing: isCaesarStone ? false : settings.enableSharing,
    showLanguageSelect: isCaesarStone || isDeStefano ? false : settings.showLanguageSelect,
    useCategorySwitching: true,
    allowVisualizerSwitching: fabricatorResponse.useVisualizerSwitching || window.location.href.includes("allowRooms"),
    callForPricing: settings.callForPricing || fabricatorHardcode.hardCodeIsAgent() || fabricatorHardcode.hardCodeIsTorrco(),
    enableASInventorySync: (fabricatorResponse && fabricatorResponse.settings) ? fabricatorResponse.settings.enableASInventorySync : false,
    enableASProductSync: (fabricatorResponse && fabricatorResponse.settings) ? fabricatorResponse.settings.enableASProductSync : false,
    enableGInventorySync: (fabricatorResponse && fabricatorResponse.settings) ? fabricatorResponse.settings.enableGInventorySync : false,
    enableGProductSync: (fabricatorResponse && fabricatorResponse.settings) ? fabricatorResponse.settings.enableGProductSync : false,
    useTrumbleApi: (fabricatorResponse && fabricatorResponse.settings) ? fabricatorResponse.settings.useTrumbleApi : false,
    useShipperHQ: (fabricatorResponse && fabricatorResponse.settings) ? fabricatorResponse.settings.useShipperHQ : false,
    useDifferentCurrencies: (fabricatorResponse && fabricatorResponse.settings) ? fabricatorResponse.settings.useDifferentCurrencies : false,
    hideYourListButton: fabricatorResponse ? fabricatorResponse.hideYourListButton : false,
    useMarkUpFeaturesRequests: fabricatorResponse ? fabricatorResponse.useMarkUpFeaturesRequests : false,
    useFabricatorCostPrices: false,
    sureTax: false,
  });
}

export default function (state = initialState, action) {

  switch (action.type) {

    case types.SET_FABRICATOR_DATA: {
      const {settings, kitchenSettings, bathroomSettings, fireplaceSettings, laundryRoomSettings} = parseFabricatorSettings(action.payload);
      document.kvConfig.visualizerOnly = settings.visualizerOnly;
      if (document.kvConfig.isBackend && document.kvConfig.visualizerOnly) {
        document.kvConfig.visualizerOnly = !(settings.checkout && settings.showPricing) // if they are enabled - enable all pages
      }
      const finalSettings = getFinalSettings(settings, state.settings, action.payload);
      const finalKvSettings = getFinalSettings(kitchenSettings, state.settings, action.payload);
      const finalBvSettings = getFinalSettings(bathroomSettings, state.settings, action.payload);
      const finalFPSettings = getFinalSettings(fireplaceSettings, state.settings, action.payload);
      const finalLRSettings = getFinalSettings(laundryRoomSettings, state.settings, action.payload);

      console.log("finalSettings: ", finalSettings);
      // console.log("finalKvSettings", finalKvSettings);
      // console.log("finalBvSettings", finalBvSettings);
      let aiSettings = action.payload.aiSettings ? JSON.parse(action.payload.aiSettings) : {
        enableAI: Config.isDevMode()
      };
      if (action.payload.aiSettings) {
        aiSettings.enableAI = applyDashboardSetting(aiSettings, "enableAI");
      }
      return Object.assign({}, state, {
        received: true,
        ...action.payload,
        city: action.payload.city ? action.payload.city.trim() : "",
        ...fabricatorHardcode.fabricatorsHardcodeObject,
        settings: finalSettings,
        kitchenSettings: finalKvSettings,
        bathroomSettings: finalBvSettings,
        fireplaceSettings: finalFPSettings,
        laundryRoomSettings: finalLRSettings,
        wasCreatedFromFabricator: action.payload.wasCreatedFromFabricator,
        useIMEAPI: action.payload.useIMEAPI,
        useIMEAPI_PartnerId: action.payload.useIMEAPI_PartnerId,
        receiptSettings: action.payload.receiptSettings ? JSON.parse(action.payload.receiptSettings) : {
          showThumbnailsAndDescriptions: fabricatorHardcode.hardCodeIsFabricator("customfitbath", 259554)
            || fabricatorHardcode.hardCodeIsAmericanStandard()
        },
        aiSettings,
      });
    }
    case types.SET_FABRICATOR_SUBSCRIPTIONS:
      return Object.assign({}, state, {
        ...action.payload,
      });
    case types.SET_FABRICATOR_TAXES: {
      const usePercentageTaxInput = fabricatorHardcode.hardCodeIsAmericanStandard() || fabricatorHardcode.hardCodeIsFloform();
      if (usePercentageTaxInput && (!Array.isArray(action.payload.fabricatorTaxes) || !action.payload.fabricatorTaxes.length)) {
        action.payload.fabricatorTaxes = [hardcodedTaxObject];
      }
      if (!Array.isArray(action.payload.fabricatorTaxes) || !action.payload.fabricatorTaxes.length) {
        return state;
      }
      return Object.assign({}, state, {
        fabricatorTaxes: (action.payload.fabricatorTaxes || []).map((taxObject, taxObjectIndex) => {
          if (!taxObject.id) {
            taxObject.id = uuid.v4();
          }
          taxObject.state = ""; // clear to display nameIntl or Tax (Included)
          if (usePercentageTaxInput && !taxObjectIndex) {
            taxObject.isCustomEditableTax = true;
          }
          return taxObject
        }),
      });
    }
    case types.SET_SQFT_MEASURE_UNIT: {
      return Object.assign({}, state, {
        settings: Object.assign({}, state.settings, {
          measureUnit: action.payload.measureUnit,
        }),
        kitchenSettings: Object.assign({}, state.settings, {
          measureUnit: action.payload.measureUnit,
        })
      });
    }
    case types.UPDATE_FABRICATOR_SETTINGS: {
      const currentSettingsProperty = getCommonVisualizerType() + "Settings";
      const nextSettings = state[currentSettingsProperty]; // current settings
      // console.log("nextSettings", nextSettings);
      return Object.assign({}, state, {
        settings: Object.assign({}, state.settings, nextSettings)
      });
    }
    case types.TOGGLE_HIDE_ITEMS_PRICES: {
      return Object.assign({}, state, {
        hideCheckoutBreakdownCost: !state.hideCheckoutBreakdownCost
      });
    }
    case types.TOGGLE_USE_FABRICATOR_COST_PRICES: {
      const nextSettings = {useFabricatorCostPrices: action.payload.useFabricatorCostPrices}
      return Object.assign({}, state, {
        settings: Object.assign({}, state.settings, nextSettings)
      });
    }
  }

  return state;

}
